import { consume } from "@ndn/endpoint";
import { Interest, Name } from "@ndn/packet";
import { Decoder } from "@ndn/tlv";
import { Metadata, MetadataKeyword } from "./metadata_browser.js";
/**
 * Make discovery Interest.
 * @param prefix - Metadata packet prefix.
 * `32=metadata` component is optional; it will be appended automatically if absent.
 */
export function makeDiscoveryInterest(prefix) {
    let name = Name.from(prefix);
    if (!name.get(-1)?.equals(MetadataKeyword)) {
        name = name.append(MetadataKeyword);
    }
    return new Interest(name, Interest.CanBePrefix, Interest.MustBeFresh);
}
export async function retrieveMetadata(prefix, arg2, cOpts) {
    let ctor = Metadata;
    if (typeof arg2 === "function") {
        ctor = arg2;
    }
    else {
        cOpts = arg2;
    }
    const interest = makeDiscoveryInterest(prefix);
    const data = await consume(interest, {
        describe: `RDR-c(${prefix})`,
        ...cOpts,
    });
    return Decoder.decode(data.content, ctor);
}
